import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-z-add-notifications',
  templateUrl: './z-add-notifications.component.html',
  styleUrls: ['./z-add-notifications.component.scss']
})
export class ZAddNotificationsComponent implements OnInit {
formData: any = {
  user_id: null,       // new field for API
  title: '',
  message: '',

};
   public arrCoupons: any[] = [];

    public currentLang : string
errors: any = {}; // store validation errors

  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService
  ) {}

    ngOnInit(): void {
                this.currentLang = localStorage.getItem('currentLang')


                  this.apisService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })


    }
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  this.formData.image = file.name; // send only file name ✔
}


    cancel(): void {
      this.router.navigate(['/z-notifications']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  this.errors = {}; // reset previous errors

  const payload = {
    user_id: this.formData.user_id,
    title: this.formData.title,
    message: this.formData.message,

  };

  this.apisService.addnotifications(payload).subscribe({
   next: () => {
  this.toastr.success(
    this.currentLang === 'ar'
      ? 'تمت الإضافة بنجاح'
      : 'Added successfully'
  );

  this.router.navigate(['/z-notifications']);
},

error: () => {
  this.toastr.error(
    this.currentLang === 'ar'
      ? 'حدث خطأ أثناء الإضافة'
      : 'Error adding'
  );
}

  });
}


}